angular
  .module('app')
  .controller('ResetController', ResetController);

ResetController.$inject = ['Session', 'AUTH_EVENTS', 'Reset', '$rootScope'];

function ResetController(Session, AUTH_EVENTS, Reset, $rootScope) {
  var vm = this;
  vm.error = false;

  vm.resetpassword = function () {
    if (vm.credentials.checkpassword === vm.credentials.checkconfirmpassword) {
      $rootScope.loading = true;
      vm.passmismatch = false;
      var reset = Reset.save({email: vm.credentials.user, password: vm.credentials.checkpassword}).$promise;
      reset.then(function (res) {
        $rootScope.loading = false;
        Session.create(res.id, res.user);
        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
        Session.go('dashboard.main');
      });
    } else {
      vm.passmismatch = true;
    }
  };
}
